import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="text-center py-6 text-gray-400 text-sm bg-white border-t space-y-2">
      <p>© 2026 AI婚恋平台 · 婚恋有道</p>
      <p>
        <Link to="/wedding" className="text-gray-300 hover:text-gray-400 text-xs">
          婚礼服务
        </Link>
      </p>
    </footer>
  );
}